import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, EmptyState, Panel } from './UI';

type Props = {
  children: ReactNode;
  resetKey?: string;
  title?: string;
};

type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled application error', { error, componentStack: info.componentStack });
  }

  componentDidUpdate(previous: Props) {
    if (this.state.error && previous.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <Panel><EmptyState title={this.props.title || '页面暂时无法显示'} copy="分析过程中发生了未处理错误。你可以重试当前页面，原始存档不会被修改。" actions={<Button primary onClick={() => this.setState({ error: null })}>重试</Button>} /></Panel>;
  }
}
